import CategoriesTabs from "@components/BondAnalyser/Homepage/CategoriesTabs";
import DeepenYourBondExpertise from "@components/BondAnalyser/Homepage/DeepenYourBondExpertise";
import HeroBanner from "@components/BondAnalyser/Homepage/HeroBanner";
import CrackingTheBondCode from "@components/BondAnalyser/Homepage/CrackingTheBondCode";
import HomepageFeatureBlocks from "@components/BondAnalyser/Homepage/HomepageFeatureBlocks";
import { Image } from "@ui/atoms";
import AuthContext from '@context/auth';
import { useContext, useEffect } from "react";
import NextHeadTag from "@ui/molecules/NextHeadTag";
import { HeadTagData } from "@helpers/headTagData";
import { triggerCustomGaEvent } from "@helpers/miscelleanous";
import { bondAnalyserGaEventsName } from "@helpers/ga-events-name-enum";
import { logEvent, moengageEventConstants } from '@services/moengage';

const BondAnalyserPage = () => {
  const showHomepageFeatureBlocks = false;
  const { loginModal } = useContext(AuthContext);
  useEffect(() => {
        triggerCustomGaEvent(bondAnalyserGaEventsName.VIEWED_BA_HOMEPAGE);
        logEvent({
          eventName: moengageEventConstants.VIEWED_BA_HOMEPAGE
        });
    }, []);
  return (
    <>
      <NextHeadTag {...HeadTagData['/bond-analyser']} />
      <div className="relative bg-basicWhite">
        <HeroBanner />
        <div className="max-w-[1440px] mx-auto w-full bg-basicWhite relative">
          <DeepenYourBondExpertise />
          <Image src='/images/bond-analyser/bond-analyser-jiraaf-bg-vector.svg' alt='' className='absolute bottom-20 scale-150 xl:scale-100 xl:-bottom-40 object-cover w-full' />
        </div>
        <CategoriesTabs loginModal={loginModal} />
        <div className="max-w-[1440px] mx-auto w-full bg-basicWhite">
          <CrackingTheBondCode />
        </div>
        {showHomepageFeatureBlocks ? <HomepageFeatureBlocks loginModal={loginModal} /> : null}
      </div>
    </>
  )
}

export default BondAnalyserPage;